import React from 'react';
import { Outlet } from 'react-router-dom';
import Header from './Header';
import AdSenseSlot from './AdSenseSlot';

export default function Layout() {
  return (
    <div className="pub-layout">
      <Header />

      <AdSenseSlot position="header" style={{ minHeight: '90px' }} />

      <main className="pub-body">
        <Outlet />
      </main>

      <footer className="pub-footer">
        <AdSenseSlot position="footer" style={{ minHeight: '90px', marginBottom: '16px' }} />
        <div className="pub-footer-inner">
          <span className="pub-footer-brand">HOBBYGOM.</span>
          <p className="pub-footer-copy">© 2026 HOBBYGOM ALL RIGHTS RESERVED.</p>
        </div>
      </footer>
    </div>
  );
}
